// src/api/jobs.js
import { apiJson } from "./client";

// 구버전/신버전 모두 호환: uploadKeys[] 우선, 없으면 uploadKey 단일
export async function createJob(uploadBucket, uploadKeysOrKey, options = {}) {
    const uploadKeys = Array.isArray(uploadKeysOrKey)
        ? uploadKeysOrKey
        : (uploadKeysOrKey ? [uploadKeysOrKey] : []);

    // 서버가 uploadKey만 받는 경우도 있어서 둘 다 보냄
    const body = {
        uploadBucket,
        uploadKeys,
        uploadKey: uploadKeys[0],
        inputType: options.inputType || "VIDEO",
        optionsJson: options.optionsJson, // 문자열이면 그대로
        options: options.options,         // 객체면 서버가 json string으로 바꿔줌(서버 구현에 따라)
    };

    const res = await apiJson("/api/jobs", { method: "POST", body });

    // ✅ 200인데 ok:false인 케이스 방어
    if (res && res.ok === false) {
        throw new Error(res.message || "createJob failed");
    }
    return res;
}

// 예전 코드 호환용 alias
export function createJobCompat(uploadBucket, uploadKeysOrKey, options = {}) {
    return createJob(uploadBucket, uploadKeysOrKey, options);
}

export function getJob(jobId) {
    return apiJson(`/api/jobs/${jobId}`, { method: "GET" });
}

export async function listJobs() {
    // 서버가 배열을 주든 {items:[...]}를 주든 그대로 리턴
    return apiJson("/api/jobs", { method: "GET" });
}
